<template>
  <div class="parent">
    <banner v-bind:bannerObj="bannerObj"></banner>
    <div class="aboutWrap">
      <div class="who">
        <div class="titleStyle">我们是谁</div>
        <p>
          GET（Global E-tech Holding Limited），成立于2018年2月，作为一家综合性金融科技公司，致力于推动金融模式与技术创新，为全球客户提供金融<br/>科技产品及服务。
          成立至今，GET陆续在美国、香港、日本、新加坡、中国等地设立子公司，分别为GEP美国（取得全美MSB牌照）、GEP香港（取得香港MSO牌照）<br/>GEP日本（与监管沟通牌照申领事宜），GEP新加坡（与监管沟通牌照申领事宜）、GEP中国，并预计未来业务将拓展至东南亚、欧盟等地。
          为解决客户的多层次需求，<br/>GEP根据细分客户群体的行业特性，定制行业解决方案及客户个性化需求解决方案，帮助客户建立更加稳定、高效的业务模式通过技术手段的创新为客户企业管理带来效率和成本上的优势；利用大数据科学有效防范业务风险从而全面提升客户的金融服务体验，全方位助力客户的业务发展和转型。
        </p>
        <!--<div class="imgHover">-->
          <!--<div class="item">-->
            <!--<img src="../assets/images/stock.png" alt>-->
            <!--<div class="shade"></div>-->
            <!--<div class="rhomboid">-->
              <!--<span>投资管理</span>-->
              <!--<p>我们向客户提供投资决策与计划，建立资金使用和分管的责任制，检查和监督资金的使用情况，考核资金的利用效果。</p>-->
            <!--</div>-->
          <!--</div>-->
          <!--<div class="item">-->
            <!--<img src="../assets/images/bag.png" alt>-->
            <!--<div class="shade"></div>-->
            <!--<div class="rhomboid">-->
              <!--<span>资金管理</span>-->
              <!--<p>我们向客户提供投资决策与计划，建立资金使用和分管的责任制，检查和监督资金的使用情况，考核资金的利用效果。</p>-->
            <!--</div>-->
          <!--</div>-->
          <!--<div class="item">-->
            <!--<img src="../assets/images/women.png" alt>-->
            <!--<div class="shade"></div>-->
            <!--<div class="rhomboid">-->
              <!--<span>基金信托</span>-->
              <!--<p>我们向客户提供投资决策与计划，建立资金使用和分管的责任制，检查和监督资金的使用情况，考核资金的利用效果。</p>-->
            <!--</div>-->
          <!--</div>-->
          <!--<div class="item">-->
            <!--<img src="../assets/images/handshake.png" alt>-->
            <!--<div class="shade"></div>-->
            <!--<div class="rhomboid">-->
              <!--<span>供应商管理及融资</span>-->
              <!--<p>我们向客户提供投资决策与计划，建立资金使用和分管的责任制，检查和监督资金的使用情况，考核资金的利用效果。</p>-->
            <!--</div>-->
          <!--</div>-->
        <!--</div>-->
      </div>
      <div class="develop">
        <div class="titleStyle">我们的发展历程</div>
        <!--<p>GEP是国际结算行业的创新引领者，改变了国际跨境收款的格局和运行方式。 自成立以来，-->
          <!--<br>已获得多家金融从业资质及牌照，包括香港MSO牌照、美国MSB备案、新加坡支付牌照等，也是率先在欧美主流国家获得监管准入的机构。-->
        <!--</p>-->
      </div>
    </div>
    <div class="bigData">
      <!--<div>-->
        <!--<div class="item">-->
          <!--<span>2018<i>年</i></span>-->
          <!--<p>公司成立时间</p>-->
        <!--</div>-->
        <!--<div class="item">-->
          <!--<span>5<i>家</i></span>-->
          <!--<p>分公司</p>-->
        <!--</div>-->
        <!--<div class="item">-->
          <!--<span>324<i>+</i></span>-->
          <!--<p>覆盖区域</p>-->
        <!--</div>-->
        <!--<div class="item">-->
          <!--<span>680<i>+</i></span>-->
          <!--<p>服务客户</p>-->
        <!--</div>-->
        <!--<div class="item">-->
          <!--<span>200<i>亿</i></span>-->
          <!--<p>国际结算</p>-->
        <!--</div>-->
      <!--</div>-->
    </div>
    <div class="aboutWrap">
      <div class="company">
        <div class="titleStyle">我们的企业理念</div>
        <!--<p>GEP是国际结算行业的创新引领者，改变了国际跨境收款的格局和运行方式。 自成立以来，-->
          <!--<br>已获得多家金融从业资质及牌照，包括香港MSO牌照、美国MSB备案、新加坡支付牌照等，也是率先在欧美主流国家获得监管准入的机构。-->
        <!--</p>-->
        <div class="concept">
          <div class="item">
            <span>使命</span>
            <div>
              <b>科技使金融更便捷</b>
              <p>Echnology makes finance easier</p>
            </div>
            <i>MISSION</i>
          </div>
          <div class="item">
            <span>愿景</span>
            <div>
              <b>成为跨境业务垂直领域中一流的金融<br/>科技公司 </b>
              <p>Becoming a leading financial technology company in the vertical field of cross-border business</p>
            </div>
            <i>VISION</i>
          </div>
          <div class="item">
            <span>价值观</span>
            <div>
              <b>从客户出发，为客户的业务创造更多的<br/>价值和机会</b>
              <p>Create more value and opportunity for the benefit of customers.</p>
            </div>
            <i>VALUES</i>
          </div>
        </div>
      </div>
    </div>
    <footer>
      <footContent></footContent>
    </footer>
  </div>
</template>

<style lang="scss">
.parent {
  font-family: PingFangSC-Medium, sans-serif;
  background-color: #fff;
  .aboutWrap {
    width: 1200px;
    margin: 80px auto;
    > div {
      margin-bottom: 80px;
    }
    .titleStyle {

      width: 400px;
      font-size: 30px;
      line-height: 60px;
      margin: 0 auto 30px auto;
      text-align: center;
      border-bottom: 1px solid rgba(235, 235, 235, 1);
      position: relative;
      &:after {
        content: "";
        width: 8px;
        height: 8px;
        background: rgba(255, 203, 51, 1);
        position: absolute;
        left: 0;
        right: 0;
        bottom: -4px;
        margin: auto;
      }
    }
    .who {
      p {
        font-family: NewPingfangMedium;
        text-align: center;
        line-height: 30px;
        color: rgba(50, 50, 50, .79);
      }
      .imgHover {
        margin-top: 40px;
        display: flex;
        flex-flow: row nowrap;
        justify-content: space-between;
        align-items: center;
        .item {
          width: 300px;
          height: 360px;
          overflow: hidden;
          position: relative;
          cursor: pointer;
          &:hover {
            .shade {
              /*transform: translate(0, 360px)*/
              background: rgba(0, 0, 0, 0);
            }
            .rhomboid {
              transform: translate(0, -180px);
              span {
                color: #fff;
              }
              &:after {
                background: rgba(18, 10, 76, 0.7);
              }
            }
          }
          img {
            display: block;
            width: 100%;
            height: 100%;
          }
          .shade {
            transform: translate(0, 0);
            background: rgba(0, 0, 0, 0.3);
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            margin: auto;
            z-index: 1;
            transition: all 200ms;
          }
          .rhomboid {
            position: absolute;
            width: 300px;
            height: 360px;
            top: 312px;
            left: 0;
            z-index: 2;
            transform: translate(0, 0);
            transition: all 400ms;
            span {
              display: block;
              font-weight: bold;
              text-align: right;
              padding: 14px 20px;
              font-size: 18px;
              color: #000;
              transition: all 400ms;
            }
            p {
              display: block;
              color: #fff;
              font-size: 14px;
              line-height: 24px;
              margin-top: 10px;
              text-align: left;
              padding: 0 20px;
            }
            &:after {
              content: "";
              background: rgba(237, 237, 237, 1);
              transform: skewY(-18deg);
              position: absolute;
              top: 0;
              right: 0;
              bottom: 0;
              left: 0;
              margin: auto;
              z-index: -1;
              transition: all 400ms;
            }
          }
        }
      }
    }
    .develop {
      p {
        line-height: 30px;
        text-align: center;
      }
    }
    .company {
      & > p {
        line-height: 30px;
        text-align: center;
      }
      .concept {
        display: flex;
        flex-flow: row nowrap;
        justify-content: space-between;
        align-items: center;
        .item {
          width: 26%;
          height: 280px;
          margin-top: 40px;
          padding: 30px;
          border-top-left-radius: 20px;
          border-bottom-right-radius: 20px;
          box-shadow: 0 0 30px rgba(0, 0, 0, 0.2);
          overflow: hidden;
          position: relative;
          &:after {
            content: "";
            width: 16px;
            height: 100%;
            position: absolute;
            right: 0;
            top: 0;
            bottom: 0;
            margin: auto;
            z-index: 1;
            /* Permalink - use to edit and share this gradient: http://colorzilla.com/gradient-editor/#2f23a2+0,523fc6+100 */
            background: #2f23a2; /* Old browsers */
            background: -moz-linear-gradient(
              top,
              #2f23a2 0%,
              #523fc6 100%
            ); /* FF3.6-15 */
            background: -webkit-linear-gradient(
              top,
              #2f23a2 0%,
              #523fc6 100%
            ); /* Chrome10-25,Safari5.1-6 */
            background: linear-gradient(
              to bottom,
              #2f23a2 0%,
              #523fc6 100%
            ); /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */
            filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#2f23a2', endColorstr='#523fc6',GradientType=0 ); /* IE6-9 */
          }
          i {
            display: block;
            text-align: center;
            font-size: 50px;
            color: rgba(50, 50, 50, 0.09);
            font-weight: 900;
            position: absolute;
            bottom: -14px;
            left: 0;
            right: 0;
            margin: auto;
            z-index: 1;
          }
          span {
            display: inline-block;
            color: rgba(55, 44, 118, 1);
            font-size: 24px;
            font-weight: bold;
            line-height: 60px;
            padding-right: 60px;
            border-bottom: 1px solid rgba(235, 235, 235, 1);
            margin-bottom: 40px;
            position: relative;
            &:after {
              content: "";
              width: 8px;
              height: 8px;
              background: rgba(255, 203, 51, 1);
              position: absolute;
              bottom: -4px;
              left: 0;
              z-index: 1;
            }
          }
          & > div {
            margin-bottom: 10px;
            b {
              display: block;
              font-weight: bold;
              margin-bottom: 8px;
              line-height: 24px;
              color: rgba(50, 50, 50, .79);
            }
            p {
              font-family: NewPingfang;
              color: rgba(50, 50, 50, 0.4);
              line-height: 19px;
              font-size: 16px;
            }
          }
        }
      }
    }
  }
  .bigData {
    margin-top: -40px;
    margin-bottom: 150px;
    width: 100%;
    height: 358px;
    background: url("../assets/images/shijianzhou.png") top no-repeat;
    backgroud-size: 100% auto;
    & > div {
      width: 1200px;
      height: 204px;
      margin: 0 auto;
      display: flex;
      flex-flow: row nowrap;
      justify-content: space-between;
      align-items: center;
      .item {
        span {
          color: rgba(255, 203, 51, 1);
          font-size: 40px;
          font-weight: bold;
          i {
            color: #fff;
            font-size: 20px;
            font-weight: normal;
          }
        }
        p {
          color: #fff;
          text-align: center;
          margin-top: 20px;
        }
      }
    }
  }
}
</style>


<script>
import store from "../vuex";
import DetailBanner from "../components/DetailBanner";
import FootContent from "../components/FootContent.vue";

// import Child from '../components/Child.vue'
export default {
  data() {
    return {
      bannerObj: {
        imgUrl: require("../assets/images/products.png"),
        text: "ABOUT US"
      }
    };
  },
  components: {
    banner: DetailBanner,
    footContent: FootContent,
  },
  store
};
</script>

